import { MoreHorizontal } from "lucide-react";
import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { BreadcrumbEllipsisProps } from "../types";

function BreadcrumbEllipsis({
  className,
  children,
  ...props
}: BreadcrumbEllipsisProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <span
      data-slot="breadcrumb-ellipsis"
      role="presentation"
      aria-hidden="true"
      className={cn(
        "flex size-9 items-center justify-center",
        className,
        classes,
      )}
      {...native}
    >
      <MoreHorizontal className="size-4" />
      <span className="sr-only">More</span>
    </span>
  );
}

BreadcrumbEllipsis.displayName = "Breadcrumb.Ellipsis";

export default BreadcrumbEllipsis;
